import * as setup from '@/setup';
import Button from '@/objects/button';
import GameTab from '@/objects/game-tab';
import Header from '@/objects/header';
import * as auth from '@/utils/auth';
import axios from 'axios';
import * as config from '@/config-APP_TARGET';
import { HEADER_HEIGHT } from '@/constants';

export default class Profile extends Phaser.Scene {
	constructor() {
		super({ key: 'Profile' });
		this.userData = null;
		this.allStats = null;
		// Usa il game_id corrente dal localStorage, con fallback a 1
		this.selectedGameId = auth.getGameId() || 1;
		this.allRankings = null;
		this.editFormVisible = false;
		this.gameTabs = [];
		this.statsContainer = null;
		this.skillContainer = null;
		this.skillSectionY = 0;
	}

	create() {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;

		// Background
		this.add
			.image(centerX, height / 2, 'background')
			.setOrigin(0.5, 0.5);

		// Header con "PROFILE"
		this.createHeader(centerX);

		// Carica dati utente e statistiche
		this.loadUserData();
	}

	createHeader(centerX) {
		const headerY = HEADER_HEIGHT / 2;

		// Usa il componente Header
		new Header(this, 'PROFILO');

		// Pulsante back (icona) - separato dal componente Header
		const backArrow = this.add.image(40, headerY, 'back-icon');
		backArrow.setOrigin(0, 0.5);
		backArrow.setInteractive({ useHandCursor: true });

		backArrow.on('pointerup', () => {
			this.scene.start('MainMenu');
		});
	}

	loadUserData() {
		var scene = this;
		var token = auth.getToken();
		var user = auth.getUser();

		// Usa dati utente da localStorage se disponibili
		if (user) {
			scene.userData = user;
		}

		// Carica statistiche da api/ranking/me (ora restituisce tutti i giochi)
		axios.get(config.apiUrl + '/api/ranking/me', {
			headers: {
				'Authorization': 'Bearer ' + token
			}
		})
		.then(function(response) {
			if (response.data && response.data.success && response.data.rankings) {
				scene.allStats = response.data.rankings;
			}
			// Carica tutti i ranking con skill per tutti i giochi
			return axios.get(config.apiUrl + '/api/ranking/all', {
				headers: {
					'Authorization': 'Bearer ' + token
				}
			});
		})
		.then(function(response) {
			if (response.data && response.data.success && response.data.rankings) {
				scene.allRankings = response.data.rankings;
			}
			// Carica anche dati utente aggiornati
			return axios.get(config.apiUrl + '/api/auth/me', {
				headers: {
					'Authorization': 'Bearer ' + token
				}
			});
		})
		.then(function(response) {
			if (response.data && response.data.success && response.data.user) {
				scene.userData = response.data.user;
				auth.saveUser(response.data.user);
			}
			scene.displayProfile();
		})
		.catch(function(error) {
			console.error('Errore caricamento dati profilo:', error);
			// Mostra comunque il profilo con dati disponibili
			scene.displayProfile();
		});
	}

	/**
	 * Restituisce le statistiche del gioco selezionato
	 * @returns {Object|null} - Oggetto con le statistiche del gioco selezionato
	 */
	getSelectedStats() {
		if (!this.allStats || !this.allStats.length) {
			return null;
		}
		var scene = this;
		var found = null;
		this.allStats.forEach(function(stat) {
			if (stat.game_id === scene.selectedGameId) {
				found = stat;
			}
		});
		return found;
	}

	/**
	 * Formatta numeri grandi con suffissi k (migliaia) e M (milioni)
	 * @param {number} score - Il punteggio da formattare
	 * @returns {string} - Stringa formattata (es. "999", "1.5k", "2.3M")
	 */
	formatLargeNumber(score) {
		if (!score && score !== 0) {
			return '0';
		}

		const num = parseInt(score, 10);

		if (num < 1000) {
			return String(num);
		} else if (num < 1000000) {
			const kValue = num / 1000;
			// Arrotonda a 1 decimale se necessario
			if (kValue % 1 === 0) {
				return String(kValue) + 'k';
			} else {
				return kValue.toFixed(1) + 'k';
			}
		} else {
			const mValue = num / 1000000;
			// Arrotonda a 1 decimale se necessario
			if (mValue % 1 === 0) {
				return String(mValue) + 'M';
			} else {
				return mValue.toFixed(1) + 'M';
			}
		}
	}

	displayProfile() {
		var width = this.sys.game.config.width;
		var centerX = width / 2;
		var startY = 140;
		var scene = this;

		// Avatar placeholder (quadrato bianco)
		var avatarSize = 0;
		var avatarX = 40;
		var avatarY = startY + 60;

		// Nome utente con nickname
		var nickname = this.userData && this.userData.nickname ? this.userData.nickname : 'User';
		var nicknameText = this.add.text(avatarX + avatarSize + 30, startY + 20, nickname.toUpperCase() + "'S", {
			fontSize: 48,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'left',
			stroke: '#1567a3',
			strokeThickness: 3
		}).setOrigin(0, 0);

		// Icona edit accanto al nickname
		var editIconX = avatarX + avatarSize + 30 + nicknameText.width + 15;
		var editIconY = startY + 25 + nicknameText.height / 2;
		var editIcon = this.add.image(editIconX, editIconY, 'edit-icon');
		editIcon.setScale(0.3);
		editIcon.setOrigin(0, 0.5);
		editIcon.setInteractive({ useHandCursor: true });
		editIcon.on('pointerup', function() {
			if (!scene.editFormVisible) {
				scene.showEditForm();
			}
		});

		// Email utente
		var email = this.userData && this.userData.email ? this.userData.email : '';
		this.add.text(avatarX + avatarSize + 30, startY + 70, email, {
			fontSize: 24,
			fontFamily: 'Arial',
			fill: '#FFFFFF',
			align: 'left'
		}).setOrigin(0, 0);

		// Icona punti (score-icon) con totale punti del gioco selezionato
		var stats = this.getSelectedStats();
		var totalPoints = stats && stats.total_score ? stats.total_score : 0;
		var pointsIcon = this.add.image(width - 150, startY + 40, 'score-icon');
		pointsIcon.setScale(0.4);

		var pointsBg = this.add.rectangle(width - 50, startY + 40, 100, 50, 0x333333, 0.8);
		pointsBg.setStrokeStyle(2, 0x666666);

		this.pointsText = this.add.text(width - 50, startY + 40, this.formatLargeNumber(totalPoints), {
			fontSize: 36,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center'
		}).setOrigin(0.5);

		// Calcola la posizione Y per i bottoni dei giochi (prima delle skill)
		var minStatsY = avatarY + 100;
		var gameButtonsY = Math.max(avatarY + 60 + 120, minStatsY) - 10;

		// Crea i bottoni per selezionare il gioco
		this.createGameButtons(centerX, gameButtonsY);

		// Salva la posizione Y per la sezione SKILL (dopo i bottoni)
		this.skillSectionY = gameButtonsY + 80;
		this.skillStartX = avatarX + avatarSize + 30;

		// Mostra le skill del gioco selezionato
		this.updateSkillDisplay();

		// Posizione per le sezioni STATS (dopo le skill)
		this.statsStartY = this.skillSectionY + 200;

		// Crea le sezioni STATS
		this.updateStatsDisplay();
	}

	/**
	 * Crea i tab per selezionare il gioco usando il componente GameTab.
	 *
	 * @param {number} centerX - Posizione X centrale.
	 * @param {number} y - Posizione Y.
	 */
	createGameButtons(centerX, y) {
		var scene = this;
		var width = this.sys.game.config.width;
		var games = this.allStats || [];

		// Distruggo i tab precedenti se esistono
		if (this.gameTabs && this.gameTabs.length > 0) {
			this.gameTabs.forEach(function(tab) {
				if (tab && tab.destroy) {
					tab.destroy();
				}
			});
		}
		this.gameTabs = [];

		// Se non ci sono giochi, non creare tab
		if (games.length === 0) {
			return;
		}

		// Larghezza proporzionale
		var tabWidth = width / games.length;

		games.forEach(function(game, index) {
			var tabX = (index * tabWidth) + (tabWidth / 2);
			var isSelected = game.game_id === scene.selectedGameId;

			// Creo il tab usando il componente GameTab
			var tab = new GameTab(
				scene,
				tabX,
				y,
				tabWidth - 10,
				game.game_name,
				isSelected
			);

			// Salvo il gameId nel tab per riferimento
			tab.gameId = game.game_id;

			// Event handler per il click sul tab
			tab.on('pointerdown', function() {
				if (scene.selectedGameId !== game.game_id) {
					scene.selectGame(game.game_id);
				}
			});

			scene.gameTabs.push(tab);
		});
	}

	/**
	 * Seleziona un gioco e aggiorna la visualizzazione delle stats.
	 *
	 * @param {number} gameId - ID del gioco da selezionare.
	 */
	selectGame(gameId) {
		this.selectedGameId = gameId;

		// Aggiorna lo stato di selezione di tutti i tab
		this.updateTabsSelection();

		// Aggiorna il punteggio totale in alto
		var stats = this.getSelectedStats();
		var totalPoints = stats && stats.total_score ? stats.total_score : 0;
		if (this.pointsText) {
			this.pointsText.setText(this.formatLargeNumber(totalPoints));
		}

		// Aggiorna le skill e le sezioni STATS
		this.updateSkillDisplay();
		this.updateStatsDisplay();
	}

	/**
	 * Aggiorna lo stato di selezione di tutti i tab.
	 */
	updateTabsSelection() {
		var scene = this;
		if (this.gameTabs) {
			this.gameTabs.forEach(function(tab) {
				tab.setSelected(tab.gameId === scene.selectedGameId);
			});
		}
	}

	/**
	 * Restituisce le skill del gioco selezionato
	 * @returns {Object|null} - Oggetto ranking con le skill del gioco selezionato
	 */
	getSelectedRanking() {
		if (!this.allRankings || !this.allRankings.length) {
			return null;
		}

		// Ottieni il nome del gioco selezionato da allStats
		var selectedStats = this.getSelectedStats();
		if (!selectedStats || !selectedStats.game_name) {
			return null;
		}

		var selectedGameName = selectedStats.game_name;
		var found = null;

		// Cerca in allRankings per nome del gioco
		this.allRankings.forEach(function(ranking) {
			if (ranking && ranking.game === selectedGameName) {
				found = ranking;
			}
		});
		return found;
	}

	/**
	 * Aggiorna la visualizzazione delle skill del gioco selezionato
	 */
	updateSkillDisplay() {
		var scene = this;
		var skillLineHeight = 30;

		// Distruggi il container precedente se esiste
		if (this.skillContainer) {
			this.skillContainer.destroy();
		}

		// Crea un nuovo container per le skill
		this.skillContainer = this.add.container(0, 0);

		// Ottieni il ranking del gioco selezionato
		var gameRanking = this.getSelectedRanking();

		if (gameRanking && gameRanking.skills && gameRanking.skills.length > 0) {
			var skillY = this.skillSectionY;

			// Nome del gioco (giallo come in howtoplay)
			var gameTitle = this.add.text(this.skillStartX, skillY, gameRanking.game.toUpperCase(), {
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: '#eccc36',
				align: 'left'
			}).setOrigin(0, 0);
			this.skillContainer.add(gameTitle);

			skillY += skillLineHeight + 5;

			// Skill per questo gioco
			gameRanking.skills.forEach(function(skill) {
				if (skill && skill.name) {
					var skillLevel = skill.level ? skill.level : 0;
					var skillText = scene.add.text(scene.skillStartX, skillY, 'SKILL: ' + skill.name + ' - Level ' + skillLevel, {
						fontSize: 24,
						fontFamily: 'Arial',
						fill: '#FFFFFF',
						align: 'left'
					}).setOrigin(0, 0);
					scene.skillContainer.add(skillText);
					skillY += skillLineHeight;
				}
			});
		} else {
			// Nessuna skill per questo gioco
			var noSkillText = this.add.text(this.skillStartX, this.skillSectionY, 'Nessuna skill acquisita', {
				fontSize: 24,
				fontFamily: 'Arial',
				fill: '#999999',
				align: 'left'
			}).setOrigin(0, 0);
			this.skillContainer.add(noSkillText);
		}
	}

	/**
	 * Aggiorna la visualizzazione delle sezioni STATS
	 */
	updateStatsDisplay() {
		var centerX = this.sys.game.config.width / 2;
		var stats = this.getSelectedStats();

		// Distruggi il container precedente se esiste
		if (this.statsContainer) {
			this.statsContainer.destroy();
		}

		// Crea un nuovo container per le stats
		this.statsContainer = this.add.container(0, 0);

		// Prima sezione STATS PUNTI
		var statsPointsY = this.statsStartY;
		this.createStatsSectionInContainer(centerX, statsPointsY, 'STATS PUNTI', [
			{ label: 'TOTAL', value: this.formatLargeNumber(stats && stats.total_score ? stats.total_score : 0), color: '#82a110' },
			{ label: 'ROUNDS', value: String(stats && stats.round_played ? stats.round_played : 0), color: '#82a110' },
			{ label: 'AVG', value: String(stats && stats.average_score ? Number(stats.average_score).toFixed(1) : '0.0'), color: '#82a110' }
		]);

		// Seconda sezione STATS SFIDE
		var statsChallengesY = statsPointsY + 200;
		this.createStatsSectionInContainer(centerX, statsChallengesY, 'STATS SFIDE', [
			{ label: 'PLAYED', value: String(stats && stats.challenges_played ? stats.challenges_played : 0), color: '#82a110' },
			{ label: 'WON', value: String(stats && stats.challenges_won ? stats.challenges_won : 0), color: '#82a110' },
			{ label: 'LOST', value: String(stats && stats.challenges_lost ? stats.challenges_lost : 0), color: '#e12044' }
		]);
	}

	/**
	 * Crea una sezione STATS dentro il container
	 * @param {number} centerX - Posizione X centrale
	 * @param {number} statsY - Posizione Y della sezione
	 * @param {string} title - Titolo della sezione
	 * @param {Array} stats - Array di oggetti {label, value, color}
	 */
	createStatsSectionInContainer(centerX, statsY, title, stats) {
		var scene = this;

		// Immagine superpower-menu come sfondo
		var statsMenu = this.add.image(centerX, statsY, 'superpower-menu');
		statsMenu.setScale(0.89);
		this.statsContainer.add(statsMenu);

		// Titolo STATS sopra il menu
		var statsLabel = this.add.text(centerX, statsY - statsMenu.displayHeight / 2 - 20, title, {
			fontSize: 36,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center',
			stroke: '#1567a3',
			strokeThickness: 2
		}).setOrigin(0.5);
		this.statsContainer.add(statsLabel);

		// Statistiche dentro il menu
		var statsContainerY = statsY;
		var statsSpacing = statsMenu.displayWidth / stats.length;

		stats.forEach(function(stat, index) {
			var statX = centerX - statsSpacing + (index * statsSpacing) + statsSpacing / 2 - 120;

			// Label
			var statLabel = scene.add.text(statX, statsContainerY - 45, stat.label, {
				fontSize: 24,
				fontFamily: 'Arial',
				fill: '#999999',
				align: 'center'
			}).setOrigin(0.5);
			scene.statsContainer.add(statLabel);

			// Value
			var statValue = scene.add.text(statX, statsContainerY + 20, stat.value, {
				fontSize: 56,
				fontFamily: 'Luckiest Guy',
				fill: stat.color,
				align: 'center'
			}).setOrigin(0.5);
			scene.statsContainer.add(statValue);
		});
	}

	showEditForm() {
		if (this.editFormVisible) {
			return;
		}

		this.editFormVisible = true;
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;
		const centerY = height / 2;

		// Container per il form
		this.editFormContainer = this.add.container(centerX, centerY);

		// Background semi-trasparente blu
		const bg = this.add.rectangle(0, 0, 500, 300, 0x1567a3, 0.9);
		bg.setStrokeStyle(3, 0xffffff);

		// Titolo form
		const title = this.add.text(0, -100, 'Modifica Nickname', {
			fontSize: 40,
			fontFamily: 'Luckiest Guy',
			fill: '#FFFFFF',
			align: 'center'
		}).setOrigin(0.5);

		// Imposta il valore corrente del nickname
		const currentNickname = this.userData && this.userData.nickname ? this.userData.nickname : '';
		this.nicknameValue = currentNickname;

		// Crea subito l'input HTML reale (come nel login)
		const inputWidth = 400;
		this.createNicknameInput(centerX, centerY, inputWidth);

		// Bottone Salva (affiancato a sinistra, spostato in basso di 50px)
		const saveButton = new Button(
			this,
			-100,
			80,
			'green-button',
			0.48,
			'Salva',
			false
		);

		// Bottone Annulla (affiancato a destra, spostato in basso di 50px)
		const cancelButton = new Button(
			this,
			100,
			80,
			'red-button',
			0.48,
			'Annulla',
			false
		);

		saveButton.on('pointerup', () => {
			const trimmedNickname = this.nicknameValue ? this.nicknameValue.trim() : '';
			if (!trimmedNickname || trimmedNickname.length < 2) {
				this.showError('Nickname deve essere almeno 2 caratteri');
			} else if (trimmedNickname.length > 8) {
				this.showError('Nickname non può superare 8 caratteri');
			} else {
				this.saveNickname(trimmedNickname);
			}
		});

		cancelButton.on('pointerup', () => {
			this.hideEditForm();
		});

		this.editFormContainer.add([bg, title, saveButton, cancelButton]);
	}

	/**
	 * Crea l'input HTML per il nickname posizionato sopra il form Phaser.
	 * Usa lo stesso approccio del login per calcolare la posizione con scala corretta.
	 *
	 * @param {number} centerX - Coordinata X del centro del form
	 * @param {number} centerY - Coordinata Y del centro del form
	 * @param {number} inputWidth - Larghezza dell'input in coordinate di gioco
	 */
	createNicknameInput(centerX, centerY, inputWidth) {
		// Rimuovi input precedente se presente
		if (this.nicknameInputElement) {
			document.body.removeChild(this.nicknameInputElement);
			this.nicknameInputElement = null;
		}

		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const scene = this;

		// Calcola posizione input basandosi sul canvas
		const canvas = this.sys.game.canvas;
		const canvasRect = canvas.getBoundingClientRect();

		// Calcola il fattore di scala tra le dimensioni del gioco e quelle reali del canvas
		const scaleX = canvasRect.width / width;
		const scaleY = canvasRect.height / height;

		const inputWidthScaled = inputWidth * scaleX;
		const inputHeight = 60 * scaleY;

		// Posizione Y dell'input nel canvas (relativa al centro del form, offset -20)
		const inputY = centerY - 20;

		// Calcola posizione centrata dell'input
		const inputLeft = canvasRect.left + (centerX * scaleX) - (inputWidthScaled / 2);
		const inputTop = canvasRect.top + (inputY * scaleY) - (inputHeight / 2);

		// Crea input HTML
		const input = document.createElement('input');
		input.type = 'text';
		input.placeholder = 'Nickname';
		input.maxLength = 8;
		input.value = this.nicknameValue || '';
		input.style.position = 'fixed';
		input.style.left = inputLeft + 'px';
		input.style.top = inputTop + 'px';
		input.style.width = inputWidthScaled + 'px';
		input.style.height = inputHeight + 'px';
		input.style.fontSize = Math.min(28, 24 * scaleX) + 'px';
		input.style.textAlign = 'center';
		input.style.border = '2px solid #4CAF50';
		input.style.borderRadius = '5px';
		input.style.padding = '2px';
		input.style.boxSizing = 'border-box';
		input.style.zIndex = '1000';
		input.style.fontFamily = 'Arial';
		input.style.backgroundColor = '#ffffff';
		input.style.outline = 'none';

		input.addEventListener('input', function(e) {
			scene.nicknameValue = e.target.value.trim();
		});

		input.addEventListener('keydown', function(e) {
			if (e.key === 'Enter') {
				const trimmedNickname = scene.nicknameValue ? scene.nicknameValue.trim() : '';
				if (!trimmedNickname || trimmedNickname.length < 2) {
					scene.showError('Nickname deve essere almeno 2 caratteri');
				} else if (trimmedNickname.length > 8) {
					scene.showError('Nickname non può superare 8 caratteri');
				} else {
					scene.saveNickname(trimmedNickname);
					input.blur();
				}
			} else if (e.key === 'Escape') {
				scene.hideEditForm();
				input.blur();
			}
		});

		document.body.appendChild(input);
		this.nicknameInputElement = input;

		// Focus automatico sull'input dopo un breve delay per garantire il rendering
		setTimeout(function() {
			input.focus();
			input.select();
		}, 100);
	}

	hideEditForm() {
		this.editFormVisible = false;

		// Rimuovi input DOM se presente
		if (this.nicknameInputElement) {
			document.body.removeChild(this.nicknameInputElement);
			this.nicknameInputElement = null;
		}

		// Rimuovi container form
		if (this.editFormContainer) {
			this.editFormContainer.destroy();
			this.editFormContainer = null;
		}
	}

	saveNickname(nickname) {
		const scene = this;
		const token = auth.getToken();

		// Rimuovi input DOM
		if (scene.nicknameInputElement) {
			document.body.removeChild(scene.nicknameInputElement);
			scene.nicknameInputElement = null;
		}

		// Mostra loading
		if (scene.editFormContainer) {
			scene.editFormContainer.destroy();
		}

		const width = scene.sys.game.config.width;
		const height = scene.sys.game.config.height;
		const centerX = width / 2;
		const centerY = height / 2;

		const loadingText = scene.add.text(centerX, centerY, 'Salvataggio...', {
			fontSize: 32,
			fontFamily: 'Arial',
			fill: '#FFFFFF',
			align: 'center'
		}).setOrigin(0.5);

		axios.put(config.apiUrl + '/api/auth/me', {
			nickname: nickname
		}, {
			headers: {
				'Authorization': 'Bearer ' + token
			}
		})
		.then(function(response) {
			if (response.data && response.data.success && response.data.user) {
				scene.userData = response.data.user;
				auth.saveUser(response.data.user);
				loadingText.destroy();
				scene.editFormVisible = false;
				// Ricarica la scena per mostrare i dati aggiornati
				scene.scene.restart();
			} else {
				throw new Error('Risposta non valida dal server');
			}
		})
		.catch(function(error) {
			console.error('Errore salvataggio nickname:', error);
			loadingText.destroy();
			let errorMsg = 'Errore durante il salvataggio. Riprova più tardi.';

			// Gestisci errori specifici dal server
			if (error.response && error.response.data && error.response.data.message) {
				errorMsg = error.response.data.message;
			} else if (error.response && error.response.status === 409) {
				errorMsg = 'Questo nickname è già in uso';
			} else if (error.response && error.response.status === 400) {
				errorMsg = 'Nickname non valido';
			}

			scene.showError(errorMsg);
			scene.editFormVisible = false;
		});
	}

	showError(message) {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;

		const errorText = this.add.text(centerX, height - 150, message, {
			fontSize: 28,
			fontFamily: 'Arial',
			fill: '#FF0000',
			align: 'center',
			wordWrap: { width: width - 100 }
		}).setOrigin(0.5);

		// Rimuovi errore dopo 3 secondi
		this.time.delayedCall(3000, () => {
			errorText.destroy();
		});
	}

	destroy() {
		// Rimuovi input DOM quando la scena viene distrutta
		if (this.nicknameInputElement) {
			document.body.removeChild(this.nicknameInputElement);
			this.nicknameInputElement = null;
		}
		super.destroy();
	}
}
